import * as React from 'react';
import { SVGProps } from 'react';

const SvgLike = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.8 1.25a.75.75 0 0 0-.702.487L3.881 7.65H2a.75.75 0 0 0-.75.75V14c0 .414.336.75.75.75h9.288a2.35 2.35 0 0 0 2.265-1.722l1.11-4A2.35 2.35 0 0 0 12.4 6.05H9.15V2.8A1.55 1.55 0 0 0 7.6 1.25h-.8Zm-3.15 12v-4.1h-.9v4.1h.9Zm1.5-4.714L7.32 2.75h.28a.05.05 0 0 1 .05.05v4c0 .414.336.75.75.75h4a.85.85 0 0 1 .819 1.077l-1.112 4a.85.85 0 0 1-.819.623H5.15V8.536Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLike;
